import GlobalStyles from './styles/global';
import { ThemeProvider } from 'styled-components';
import { light, dark } from './styles/theme';
import { useThemeContext } from './context/theme';

import Container from './shared/Container';
import Navigation from './sections/Navigation';
import Home from './sections/Home';
import Skills from './sections/Skills';
import Projects from './sections/Projects';
import Contact from './sections/Contact';
import Footer from './sections/Footer';

const App = () => {
  const { darkMode } = useThemeContext();

  return (
    <ThemeProvider theme={darkMode ? dark : light}>
      <GlobalStyles />
      <Navigation />
      <Container>
        <Home />
        <Skills />
        <Projects />
        <Contact />
      </Container>
      <Footer />
    </ThemeProvider>
  );
};

export default App;
